// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-col[data-v-e224fb68]{position:fixed}@media only screen and (max-width: 959px){.left-col[data-v-e224fb68]{position:relative}}button[data-v-e224fb68]{outline:none}", ""]);
// Exports
module.exports = exports;
